export default __webpack_public_path__ + "static/media/omnama.c2cb2d3f.png";